import { DateTime } from 'luxon';
import { matchPath } from 'react-router-dom';
import { CAMPAIGN_SESSION_STORAGE_KEY } from '@/constants';

const PRESERVE_ROUTE_PREFIXES = [
  '/magic',
  '/magic-page',
  '/experience',
  '/page',
  '/schedule',
];

const getCurrentUrlIfPreserved = (): string | undefined => {
  const { pathname, search } = window.location;
  if (PRESERVE_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return `${pathname}${search}`;
  }
  return undefined;
};

// Connecting a calendar to export an event from a public page is not a
// sign-up, so the server leaves any account it creates for them as invited.
export const isPublicPagePath = (pathname: string): boolean =>
  matchPath('/page/:slug', pathname) !== null;

/**
 * The `state` passed through a social sign-in provider and read back by the
 * server's OAuth callback (parseOauthState) to finish signup and redirect.
 */
export const buildOauthState = (
  redirectTo?: string,
  extra: Record<string, string | number | boolean> = {}
): string => {
  const effectiveRedirectTo = redirectTo || getCurrentUrlIfPreserved();

  const state: Record<string, string | number | boolean> = {
    ...extra,
    timeZone: DateTime.local().zoneName,
  };
  const campaign = sessionStorage.getItem(CAMPAIGN_SESSION_STORAGE_KEY);
  if (campaign) {
    state.campaign = campaign;
  }
  if (effectiveRedirectTo) {
    state.redirectTo = effectiveRedirectTo;
  }
  if (window.location.pathname.startsWith('/magic')) {
    state.app = 'magic';
  }

  return JSON.stringify(state);
};
